// src/components/ui/FieldError.tsx
// Shared inline error line for form fields — used with a per-form `errors`
// map and `attempted` flag so messages only appear after a submit attempt.
export default function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="text-red-400 text-[11px] mt-1">{message}</p>;
}
